import bgBG from "./bg-BG.json"
import csCZ from "./cs-CZ.json"
import deDE from "./de-DE.json"
import elGR from "./el-GR.json"
import enGB from "./en-US.json"
import esES from "./es-ES.json"
import frFR from "./fr-FR.json"
import itIT from "./it-IT.json"
import nlNL from "./nl-NL.json"
import noNO from "./no-NO.json"
import plPL from "./pl-PL.json"
import roRO from "./ro-RO.json"
import svSE from "./sv-SE.json"

export default {
	en: enGB,
	de: deDE,
	es: esES,
	el: elGR,
	bg: bgBG,
	cs: csCZ,
	fr: frFR,
	it: itIT,
	nl: nlNL,
	no: noNO,
	pl: plPL,
	ro: roRO,
	sv: svSE,
}
